import "./Home.module.css";
import PremiumNavigationBar from "@/reusable_sections/Header";
import TheWarmthOfCrumbHero from "./sections/TheWarmthOfCrumbHero";
import LatestNews from "./sections/LatestNews";
import ApparelCategories from "./sections/ApparelCategories";
import FeaturedHvacSystems from "./sections/FeaturedHvacSystems";
export default function HomePage() {
  return <div>
      <PremiumNavigationBar />
      <TheWarmthOfCrumbHero />
      <LatestNews />
      <ApparelCategories />
      <FeaturedHvacSystems />
    </div>;
}